<template>
  <div>
    <!-- TOOLBAR -->
    <v-app-bar flat color="red-darken-3" class="pt-1">
      <v-row align="center" justify="center" no-gutters>
        <v-app-bar-title class="hidden-sm-and-down ml-2">
          Cloned Parts
        </v-app-bar-title>
        <v-divider class="mx-1 hidden-sm-and-down" inset vertical />
        <v-spacer class="hidden-sm-and-down" />

        <v-text-field
          v-model.trim="searchId"
          :label="$t('parts.inventory.id')"
          flat
          variant="solo"
          color="grey-darken-4"
          append-inner-icon="mdi-magnify"
          single-line
          hide-details
          clearable
          autocomplete="off"
          @keyup.enter="searchById"
          @click:append-inner="searchById"
          @click:clear="clearSearch"
        />

        <v-spacer class="hidden-md-and-down" />
      </v-row>
    </v-app-bar>

    <v-row v-if="alert.value" justify="center">
      <v-col xs="12" class="pa-2">
        <v-alert :value="alert.value" :type="alert.type">
          {{ $t(alert.message) }}
        </v-alert>
      </v-col>
    </v-row>
    <v-data-table-server
      v-model="selected"
      v-model:options="pagination"
      :headers="
        $store.getters.role === 'LekoAdmin' ||
        $store.getters.role === 'SuperAdmin'
          ? headersAdmin
          : headers
      "
      :items="parts"
      :items-length="totalItems"
      :items-per-page="pagination.itemsPerPage"
      :items-per-page-options="[
        { value: 5, title: '5' },
        { value: 10, title: '10' },
        { value: 25, title: '25' },
        { value: 50, title: '50' },
      ]"
      items-per-page-text="Rows per page"
      item-value="_id"
      return-object
      show-select
      :loading="loading"
      class="elevation-1 pb-12 nowrap-headers"
      @update:options="updatePagination"
    >
      <template #item="{ item, index }">
        <tr
          :class="{ tableRowColorSelected: index === activeRow }"
          :style="checkMovement(item) ? 'background-color: #afabab;' : ''"
          class="tableRowColor"
          @click="activeRow = activeRow === index ? null : index"
        >
          <!-- SELECTION -->
          <td>
            <v-row align="center" justify="center">
              <v-checkbox
                :model-value="selected.includes(item)"
                :disabled="item.status === 4 || item.status === 5"
                color="primary"
                hide-details
                dense
                @change="toggleSelection(item)"
              />
            </v-row>
          </td>

          <!-- QR Code -->
          <td class="ma-1 pt-1 pb-1">
            <v-row
              class="pointer g-0"
              align="center"
              justify="center"
              @click="
                openQrDialog({
                  id: item.old_id,
                  type: 'inventory',
                  car: item.car_id,
                  printed: item.printed,
                })
              "
            >
              <qr-code :size="60" :text="item.old_id" />
              <h4>{{ item.old_id.slice(-6) }}</h4>
            </v-row>
          </td>

          <!-- ACTIONS -->

          <td class="text-center">
            <v-row no-gutters class="d-flex flex-nowrap">
              <!-- <v-btn
                v-if="
                  !item?.car_id &&
                  (!item?.infoCar?.metadata ||
                    item.infoCar.metadata.length === 0)
                    && !customApplicability
                "
                icon
                variant="text"
                class="ma-0"
                 @click="details(item)"
                :disabled="$store.getters.role !== 'LekoAdmin' &&
                  $store.getters.role !== 'SuperAdmin' && $store.getters.role !== 'InstitutionAdmin'"
              >
                <v-icon size="large" color="grey-darken-2"
                  >mdi-playlist-remove</v-icon
                >
              </v-btn> -->
              <v-btn icon variant="text" class="ma-0" @click="details(item)">
                <v-icon color="grey-darken-2">mdi-view-list</v-icon>
              </v-btn>
              <v-btn icon variant="text" class="ma-0" @click="edit(item)">
                <v-icon color="grey-darken-2">mdi-pencil</v-icon>
              </v-btn>
            </v-row>
            <v-row no-gutters class="d-flex flex-nowrap">
              <v-btn
                v-if="item.car_id"
                icon
                variant="text"
                class="ma-0"
                @click="viewCar(item.car_id)"
              >
                <v-icon color="grey-darken-2">mdi-car</v-icon>
              </v-btn>
              <v-btn v-else icon variant="text" disabled class="ma-0">
                <v-icon color="grey-darken-2">mdi-car-off</v-icon>
              </v-btn>
              <v-btn
                v-if="item.refusal_reason"
                icon
                variant="text"
                class="ma-0"
                @click="showRefusalReason(item.refusal_reason)"
              >
                <v-icon color="grey-darken-2">mdi-information</v-icon>
              </v-btn>
            </v-row>
          </td>
          <!---------------------------------------SHIPMENT---------------------------------------->
          <td class="pa-2" style="min-width: 170px">
            <span
              v-if="item.shipment_id"
              :style="item.car_id ? 'color:#1174d0' : ''"
            >
              {{ item.shipment_id.name }}<br />
            </span>
            <span v-if="item.shelf_data">
              {{ item.shelf_data.shelf.room_name }} -
              {{ item.shelf_data.shelf.location_code }}:
              {{ item.shelf_data.shelf.x }}, {{ item.shelf_data.shelf.y }}<br />
              <span class="caption">Mag: </span>
              <span class="font-weight-bold caption">{{
                item.shelf_data.repo
              }}</span>
            </span>
            <span v-else> - </span>
          </td>
          <!--------------------------------------LEKO GROUP--------------------------------------->
          <td>
            <v-row column>
              <v-col>
                <span
                  v-if="
                    item.infoCar &&
                    item.infoCar.description &&
                    item.infoCar.description.descriptionId &&
                    item.infoCar.description.descriptionId.group
                  "
                  class="text-xs font-weight-bold"
                >
                  <!-- eslint-disable-next-line max-len -->
                  {{
                    item.infoCar.description.descriptionId.group[
                      $store.getters.language
                    ]
                  }}
                </span>
              </v-col>
            </v-row>
          </td>
          <!-----------------------------------------GROUP----------------------------------------->
          <td>
            <v-row column>
              <v-col>
                <span
                  v-if="
                    item.infoCar &&
                    item.infoCar.description &&
                    item.infoCar.description.descriptionId &&
                    item.infoCar.description.descriptionId.category
                  "
                  class="text-xs font-weight-bold"
                >
                  <!-- eslint-disable-next-line max-len -->
                  {{
                    item.infoCar.description.descriptionId.category[
                      $store.getters.language
                    ]
                  }}
                </span>
              </v-col>
            </v-row>
          </td>
          <!-----------------------------------------TITLE----------------------------------------->
          <td class="text-xs" style="min-width: 200px">
            <v-row column>
              <v-col v-if="item.infoCar && item.infoCar.description">
                <span
                  v-if="
                    item.infoCar.description.descriptionId &&
                    item.infoCar.description.descriptionId.title
                  "
                  class="text-xs font-weight-bold"
                >
                  {{
                    item.infoCar.description.descriptionId.title[
                      $store.getters.language
                    ]
                  }}
                </span>
                <template
                  v-for="(alert, ind) in positionAlertItems(item)"
                  :key="`position-alert-${item._id}-${ind}`"
                >
                  <v-tooltip
                    v-if="item.alerts && item.alerts.status === true"
                    top
                  >
                    <template #activator="{ props }">
                      <v-icon
                        v-bind="props"
                        :color="getAlertColor(alert.type)"
                        size="18"
                        class="ml-1 cursor-pointer"
                      >
                        {{ getAlertIcon(alert.type) }}
                      </v-icon>
                    </template>

                    <span>{{ $t(alert.reason) }}</span>
                  </v-tooltip>
                </template>
                <span
                  v-if="item.infoCar.description.positionCode"
                  class="text-xs"
                >
                  &nbsp;
                  {{ getPosition(item.infoCar.description.positionCode) }}
                </span>
                <!-- Digitalization Accuracy Icon -->
                <v-tooltip v-if="item.digitalizationAccuracy" location="top">
                  <template #activator="{ props }">
                    <v-icon
                      v-bind="props"
                      :color="digitalizationAccuracyColor(item.digitalizationAccuracy)"
                      size="18"
                      class="ml-1 cursor-pointer"
                    >
                      {{ digitalizationAccuracyIcon(item.digitalizationAccuracy) }}
                    </v-icon>
                  </template>
                  <span>{{ digitalizationAccuracyLabel(item.digitalizationAccuracy) }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </td>
          <!-----------------------------------MANUFACTURER CODE----------------------------------->
          <td class="text-xs">
            <!--            {{ item.infoCar.oemCode }}-->
            {{ item.manufacturer_code }}
          </td>
          <!--------------------------------------INSTITUTION-------------------------------------->
          <td
            v-if="
              ($store.getters.role === 'LekoAdmin' ||
                $store.getters.role === 'SuperAdmin') &&
              item.institution_id
            "
            class="text-xs"
          >
            <v-chip>
              {{ item.institution_id.title }}
            </v-chip>
          </td>
          <td
            v-else-if="
              ($store.getters.role === 'LekoAdmin' ||
                $store.getters.role === 'SuperAdmin') &&
              !item.institution_id
            "
          />
          <!----------------------------------------IMAGES----------------------------------------->
          <td>
            <v-row align-center justify-center>
              <img
                :src="
                  item.images && item.images.length > 0 && item.images[0].thumb
                    ? `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${item.images[0].thumb}`
                    : `https://portal.lekotech.com/logo_small.png`
                "
                class="pointer"
                height="75"
                @click="showImages(item.images)"
              />
            </v-row>
          </td>
          <!-------------------------------------CONDITION-------------------------------------->
          <td class="text-xs">
            <span v-if="item.isNewPart">
              <v-icon>mdi-check-circle-outline</v-icon>
            </span>
          </td>
          <!-------------------------------------INFOCAR CODE-------------------------------------->
          <td class="text-xs">
            {{ item.infoCar.oemCode }}
          </td>
          <!-----------------------------------------PRICE----------------------------------------->
          <td class="text-xs" style="min-width: 130px">
            <v-row no-gutters class="d-flex flex-nowrap align-center">
              <div class="d-flex flex-nowrap mt-1">
                {{ item.price }} {{ item.currency }}
              </div>
              <!-- <v-btn
                v-if="item.infoCar && item.infoCar.oemCode"
                icon
                variant="outlined"
                size="small"
                @click="openPriceAverages(item.infoCar.oemCode)"
              >
                <v-icon color="grey-darken-2" size="small"
                  >mdi-currency-eur</v-icon
                ></v-btn
              > -->
              <v-menu
                v-model="activeEditId"
                :model-value="activeEditId === item._id"
                :close-on-content-click="false"
                activator="parent"
                offset="6"
                transition="scale-transition"
              >
                <template #activator="{ props }">
                  <v-btn
                    v-bind="props"
                    icon
                    variant="text"
                    @click.stop="toggleMenu(item)"
                  >
                    <v-icon color="grey-darken-2">mdi-pencil</v-icon>
                  </v-btn>
                </template>

                <v-card width="220" elevation="8">
                  <v-card-text class="pb-0 mb-0">
                    <v-text-field
                      v-model="editedPrice"
                      :disabled="
                        $store.getters.role === 'User' ||
                        $store.getters.role === 'EbayOperator'
                      "
                      color="red-darken-1"
                      type="number"
                      step="0.01"
                      min="0"
                      density="compact"
                      hide-details
                      variant="outlined"
                    />
                  </v-card-text>
                  <v-card-actions class="mt-0 pt-0">
                    <v-spacer></v-spacer>
                    <v-btn icon variant="text" @click="cancelPrice">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      variant="text"
                      color="primary"
                      @click="savePriceDialog"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-row>
          </td>

          <!--------------------------------------PRA NUMBER--------------------------------------->
          <td class="text-xs">
            {{ item.pra }}
          </td>
          <!-----------------------------------------NOTES----------------------------------------->
          <td class="text-xs">
            <v-row
              align="center"
              justify="center"
              class="pointer"
              style="min-width: 125px !important"
              @click="showNotes(item.notes)"
            >
              <span v-if="item.notes && item.notes.length > 40">
                {{ item.notes.substring(0, 40) }}... <v-icon>mdi-eye</v-icon
                >{{ item.notes ? "(" + item.notes.length + ")" : "" }}
              </span>
              <span v-else
                >{{ item.notes
                }}{{ item.notes ? "(" + item.notes.length + ")" : "" }}</span
              >
            </v-row>
          </td>
          <!-----------------------------------CLASSIFICATION (AI)----------------------------------->
          <td class="text-xs text-center">
            <span>
              {{
                item.classificationWithAI &&
                item.classificationWithAI.toLowerCase().includes("error")
                  ? "Image Not Analyzed"
                  : item.classificationWithAI
              }}
            </span>
            <span
              v-if="
                $store.getters.role === 'SuperAdmin' &&
                item.classificationWithAIProbability !== undefined &&
                item.classificationWithAIProbability !== null
              "
              class="text-caption text-medium-emphasis ml-1"
            >
              ({{ formatProbability(item.classificationWithAIProbability) }})
            </span>
          </td>
          <!-----------------------------------------BRAND----------------------------------------->
          <td class="text-xs">
            {{
              item.brand && item.brand.toLowerCase().includes("error")
                ? ""
                : item.brand
            }}
          </td>
          <td>
            <div class="text-center">
              <v-rating
                v-if="item.quality"
                :model-value="item.quality.rating"
                color="red"
                background-color="red-darken-4"
                readonly
                :size="16"
              />
              <v-rating
                v-else
                :model-value="0"
                color="red"
                background-color="red-darken-4"
                readonly
                :size="16"
              />
            </div>
            <div class="text-center text-truncate pb-2">
              {{ formatDate(item.date_created) }}
            </div>
            <v-row justify="center" class="pt-2 mb-1">
              <v-btn
                v-if="checkMovement(item)"
                small
                color="gray"
                variant="outlined"
                class="wrap"
                @click="movement(item)"
              >
                {{ $t("parts.status.returned") }} <br />
                ({{ $t("parts.insert_parts.inserted_parts") }})
              </v-btn>
              <v-btn
                v-else-if="item.status === 1"
                small
                color="success"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.entered") }}
              </v-btn>
              <v-btn
                v-else-if="item.status === 2"
                small
                color="error"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.returned") }}
              </v-btn>
              <v-btn
                v-else-if="item.status === 2.1"
                small
                color="error"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.returned_shop") }}
              </v-btn>
              <v-btn
                v-else-if="item.status === 3"
                small
                color="info"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.re_entered") }}
              </v-btn>
              <v-btn
                v-else-if="item.status === 4"
                small
                color="info"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.found") }}
              </v-btn>
            </v-row>
          </td>
        </tr>
        <tr v-if="parts && parts.length < 1">
          <td :colspan="headers.length" class="text-center pa-4">
            <v-alert type="info" border="left" color="red lighten-2" text>
              No data available.
            </v-alert>
          </td>
        </tr>
      </template>
    </v-data-table-server>
    <v-row
      v-if="
        $store.getters.role === 'LekoAdmin' ||
        $store.getters.role === 'InstitutionAdmin' ||
        $store.getters.role === 'SuperAdmin' ||
        $store.getters.role === 'LekoEmployee'
      "
      class="pa-2"
    >
      <v-col cols="12">
        <v-card color="grey-lighten-3" flat>
          <v-card-actions class="px-4">
            <v-row>
              <v-col :cols="$vuetify.display.smAndUp ? 'auto' : 12">
                <v-btn
                  variant="flat"
                  :color="chart.type === 'line' ? 'primary' : ''"
                  class="mr-1"
                  @click="selectChartType('line')"
                >
                  {{ $t("history.line") }}
                </v-btn>
                <v-btn
                  variant="flat"
                  :color="chart.type === 'bar' ? 'primary' : ''"
                  @click="selectChartType('bar')"
                >
                  {{ $t("history.bar") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>

          <v-divider />

          <v-card-text>
            <v-row align="center">
              <v-col cols="12" md="4">
                <v-row>
                  <v-col md="8" cols="auto" class="flex-grow-1 ml-5">
                    <v-select
                      v-model="selectedInstitutionId"
                      :items="institutionItems"
                      label="Institution"
                      item-title="title"
                      item-value="value"
                      variant="solo"
                      flat
                      clearable
                      color="red-darken-2"
                      background-color="grey-lighten-4"
                      class="mb-2 pl-5"
                      @update:model-value="getClonedPartsChart"
                    />
                    <v-select
                      v-model="chart.timePeriod"
                      :items="timePeriodItems"
                      :label="$t('home.charts.time_period')"
                      :hint="$t('home.charts.select_time_period')"
                      variant="solo"
                      flat
                      item-title="title"
                      item-value="value"
                      persistent-hint
                      color="red-darken-2"
                      background-color="grey-lighten-4"
                      class="pl-5"
                      @update:model-value="getClonedPartsChart"
                    />
                  </v-col>
                  <v-col cols="auto">
                    <v-btn variant="text" icon @click="getClonedPartsChart()">
                      <v-icon color="grey-darken-2">mdi-orbit-variant</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-date-picker
                    v-model="chart.time"
                    :type="chart.timePeriod === 'Month' ? 'month' : 'date'"
                    color="red-darken-2"
                    reactive
                  />
                </v-row>
              </v-col>
              <v-col cols="12" md="8">
                <v-row v-if="chart.loading" justify="center">
                  <v-progress-circular size="70" color="red" indeterminate />
                </v-row>
                <chart
                  v-if="!chart.loading"
                  :type="chart.type"
                  :data="chart.data"
                  class="mt-12"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="loadingPage"
      persistent
      fullscreen
      transition="fade-transition"
      content-class="d-flex align-center justify-center"
      overlay-color="black"
      overlay-opacity="0.3"
    >
      <v-card
        color="transparent"
        flat
        class="d-flex align-center justify-center"
      >
        <v-progress-circular color="#D32F2F" indeterminate size="100" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" width="auto">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert class="mb-0" variant="tonal" borer="bottom" type="error">
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete()">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn
      v-show="showScrollTop"
      icon
      class="scroll-top-btn"
      color="#F44336"
      @click="scrollToTop"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>

    <details-dialog ref="detailsDialog" @close="refreshParts" @delete-applicability="refreshParts" />
    <qr-dialog ref="qrDialog" />
    <movement-dialog ref="movementDialog" />
    <img-carousel ref="imgCarousel" />
    <view-dialog ref="viewDialog" />
    <car-dialog ref="carDialog" />
  </div>
</template>

<script>
import moment from "moment";
import VueQrCode from "vue-qr-generator";
import axios from "axios";
import getRequest from "../api/getRequest";
import deleteRequest from "../api/deleteRequest";
import putRequest from "../api/putRequest";
import DetailsDialog from "@/components/detailsDialog.vue";
import QrDialog from "@/components/qrDialog.vue";
import MovementDialog from "@/components/movementDialog.vue";
import ImgCarousel from "@/components/imgCarousel.vue";
import ViewDialog from "@/components/Inventory/viewDialog.vue";
import CarDialog from "@/components/carDialog.vue";
import Chart from "@/components/chart.vue";
let lastRequestId = 0;
export default {
  components: {
    "qr-code": VueQrCode,
    "details-dialog": DetailsDialog,
    "qr-dialog": QrDialog,
    "movement-dialog": MovementDialog,
    "img-carousel": ImgCarousel,
    "view-dialog": ViewDialog,
    "car-dialog": CarDialog,
    chart: Chart,
  },

  data: () => ({
    searchId: "",
    searchObject: { type: null, data: {} },
    loading: false,
    loadingPage: false,
    activeRow: null,
    pagination: {
      itemsPerPage: 5,
      page: 1,
      groupBy: ["date_created"],
      sortBy: { key: "date_created", order: "desc" },
      sortDesc: [true],
    },
    selected: [],
    totalItems: 0,
    parts: [],
    headers: [],
    headersAdmin: [
      {
        title: "",
        sortable: true,
        key: "_id",
      },
      {
        title: "",
        sortable: false,
        key: "actions",
      },
      {
        title: "",
        sortable: true,
        key: "shipment_id",
      },
      {
        title: "",
        sortable: true,
        key: "leko_group",
      },
      {
        title: "",
        sortable: true,
        key: "group",
      },
      {
        title: "",
        sortable: true,
        key: "infoCar.description.descriptionId.title.it",
      },
      {
        title: "",
        sortable: false,
        key: "manufacturer_code",
      },
      {
        title: "",
        sortable: false,
        key: "institution_id",
      },
      {
        title: "",
        sortable: false,
        key: "images",
      },
      {
        title: "",
        sortable: false,
        key: "isNewPart",
      },
      {
        title: "",
        sortable: false,
        key: "oemCode",
      },
      {
        title: "",
        sortable: true,
        key: "price",
      },
      {
        title: "",
        sortable: true,
        key: "pra",
      },
      {
        title: "",
        sortable: false,
        key: "notes",
      },
      {
        title: "",
        sortable: false,
        key: "classificationWithAI",
      },
      {
        title: "",
        sortable: true,
        key: "brand",
      },
      {
        title: "",
        sortable: true,
        key: "status",
      },
      // {
      //   text: '',
      //   sortable: true,
      //   value: 'status',
      // },
    ],
    alert: {
      value: false,
      type: "success",
      message: "",
    },
    statusMap: {},
    // baseUrl: 'http://localhost:3000',
    // baseUrl: 'https://api.lekotech.com',
    idToDelete: null,
    kromedaToDelete: null,
    dialogDelete: false,
    editDialog: false,
    editedPrice: null,
    currentItem: null,
    activeEditId: null,
    showScrollTop: false,
    institutions: [],
    selectedInstitutionId: null,
    chart: {
      loading: true,
      data: null,
      type: "bar",
      timePeriod: "Month",
      time: new Date().toISOString().substr(0, 7),
    },
    timePeriodItems: [
      { title: "Month", value: "Month" },
      { title: "Week", value: "Week" },
      { title: "Day", value: "Day" },
    ],
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
    filteredItemsByStatusAndDate() {
      const desiredStatusValue = 2;
      const desiredDate = moment("2023-04-19");

      return this.items.filter((item) => {
        const itemDate = moment(item.date_created, "YYYYMMDD");
        return (
          item.status === desiredStatusValue &&
          itemDate.isSame(desiredDate, "day")
        );
      });
    },
    institutionItems() {
      return [
        { title: "All Institutions", value: null },
        ...this.institutions.map((institution) => ({
          title: institution.title,
          value: institution._id,
        })),
      ];
    },
  },
  watch: {
    selected: {
      handler(data) {
        if (data.length > 0) {
          this.$emit("selected", { value: true, items: data });
        } else {
          this.$emit("selected", { value: false, items: data });
        }
      },
      deep: true,
      immediate: true,
    },
    searchObject: {
      handler(value) {
        if (value.type === null) {
          this.getParts();
        } else if (value.type === "regularSearch") {
          this.regularSearch(value.data);
        } else if (value.type === "advancedSearch") {
          this.advancedSearch(value.data);
        } else {
          //
        }
      },
      deep: true,
      immediate: true,
    },
    pagination: {
      handler(newVal, oldVal) {
        // console.log(newVal, oldVal);
        // if (
        //   newVal.page !== oldVal.page ||
        //   newVal.itemsPerPage !== oldVal.itemsPerPage ||
        //   JSON.stringify(newVal.sortBy) !== JSON.stringify(oldVal.sortBy) ||
        //   JSON.stringify(newVal.sortDesc) !== JSON.stringify(oldVal.sortDesc)
        // ) {
        if (this.searchObject.type === null) {
          this.getParts();
        } else if (this.searchObject.type === "regularSearch") {
          this.regularSearch(this.searchObject.data);
        } else if (this.searchObject.type === "advancedSearch") {
          this.advancedSearch(this.searchObject.data);
        }
        // }
      },
      deep: true,
      immediate: true,
    },
    parts(value) {
      this.$emit("items", value);
    },
    "$i18n.locale"() {
      this.getLocale();
    },
    "chart.time": {
      handler() {
        if (this.chart && this.chart.data && !this.chart.loading) {
          this.getClonedPartsChart();
        }
      },
      deep: true,
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  beforeMount() {
    // this.getParts();
    this.getLocale();
    this.fetchInstitutions();
    this.getClonedPartsChart();
  },

  methods: {
    async fetchInstitutions() {
      try {
        const response = await getRequest("/institution/");
        this.institutions = response?.institutions || [];
      } catch {
        this.institutions = [];
      }
    },
    searchById() {
      if (this.searchId.length > 0) {
        this.searchObject = {
          type: "regularSearch",
          data: {
            type: "id",
            searchField: this.searchId,
            titleCode: null,
            titleCodes: null,
            note: "",
            code: "",
          },
        };
      } else {
        this.clearSearch();
      }
    },
    clearSearch() {
      this.searchId = "";
      this.searchObject = { type: null, data: {} };
    },
    formatDate(date) {
      if (!date) return "";
      moment.locale(localStorage.getItem("language") || "en");
      return moment(date).format("LLL");
    },
    openPriceAverages(code) {
      this.$emit("average-prices", code);
    },
    openAddEbay(item) {
      this.$emit("add-ebay", item);
    },
    openDeleteEbay(item) {
      this.$emit("delete-ebay", item);
    },
    openAddGoogle(item) {
      this.$emit("add-google", item);
    },
    openDeleteGoogle(item) {
      this.$emit("delete-google", item);
    },
    checkKtypes(item) {
      this.$emit("check-ktypes", item);
    },
    openEditTitleEbay(item) {
      this.$emit("edit-ebay-title", item);
    },
    getLocale() {
      this.timePeriodItems[0].title = this.$t("home.charts.time_period_items.month");
      this.timePeriodItems[1].title = this.$t("home.charts.time_period_items.week");
      this.timePeriodItems[2].title = this.$t("home.charts.time_period_items.day");

      const allHeaders = [
        { title: this.$t("parts.table.qr_code"), key: "_id", sortable: true },
        {
          title: this.$t("parts.table.actions"),
          key: "actions",
          sortable: false,
        },
        {
          title: this.$t("parts.table.shipment"),
          key: "shipment_id",
          sortable: true,
        },
        {
          title: this.$t("parts.table.leko_group"),
          key: "leko_group",
          sortable: true,
        },
        { title: this.$t("parts.table.group"), key: "group", sortable: true },
        {
          title: this.$t("parts.table.title"),
          key: "infoCar.description.descriptionId.title.it",
          sortable: true,
        },
        {
          title: this.$t("parts.table.manufacturer_code"),
          key: "manufacturer_code",
          sortable: false,
        },
        {
          title: this.$t("parts.table.images"),
          key: "images",
          sortable: false,
        },
        {
          title: this.$t("parts.table.new"),
          key: "isNewPart",
          sortable: false,
        },
        {
          title: this.$t("parts.table.oem_code"),
          key: "oemCode",
          sortable: false,
        },
        { title: this.$t("parts.table.price"), key: "price", sortable: true },
        { title: this.$t("parts.table.pra"), key: "pra", sortable: true },
        { title: this.$t("parts.table.notes"), key: "notes", sortable: false },
        {
          title: this.$t("parts.table.classification_with_ai"),
          key: "classificationWithAI",
          sortable: false,
        },
        { title: this.$t("parts.table.brand"), key: "brand", sortable: true },
        {
          title: this.$t("parts.table.date_created"),
          key: "date_created",
          sortable: true,
        },
      ];

      this.headers = allHeaders;
      if (
        this.$store.getters.role === "LekoAdmin" ||
        this.$store.getters.role === "SuperAdmin"
      ) {
        this.headersAdmin[0].title = this.$t("parts.table.qr_code");
        this.headersAdmin[1].title = this.$t("parts.table.actions");
        this.headersAdmin[2].title = this.$t("parts.table.shipment");
        this.headersAdmin[3].title = this.$t("parts.table.leko_group");
        this.headersAdmin[4].title = this.$t("parts.table.group");
        this.headersAdmin[5].title = this.$t("parts.table.title");
        this.headersAdmin[6].title = this.$t("parts.table.manufacturer_code");
        this.headersAdmin[7].title = this.$t("parts.table.institution");
        this.headersAdmin[8].title = this.$t("parts.table.images");
        this.headersAdmin[9].title = this.$t("parts.table.new");
        this.headersAdmin[10].title = this.$t("parts.table.oem_code");
        this.headersAdmin[11].title = this.$t("parts.table.price");
        this.headersAdmin[12].title = this.$t("parts.table.pra");
        this.headersAdmin[13].title = this.$t("parts.table.notes");
        this.headersAdmin[14].title = this.$t("parts.table.classification_with_ai");
        this.headersAdmin[15].title = this.$t("parts.table.brand");
        this.headersAdmin[16].title = this.$t("parts.table.date_created");
      }
    },
    formatProbability(value) {
      if (value === undefined || value === null || value === "") return "";
      const num = Number(value);
      if (!Number.isFinite(num)) return "";
      const percent = num <= 1 ? num * 100 : num;
      return `${Math.round(percent)}%`;
    },
    getChartLabel(bucket) {
      if (this.chart.timePeriod === "Day") {
        return `${moment(bucket.startingTime).format("LT")} - ${moment(bucket.endingTime).format("LT")}`;
      }
      if (this.chart.timePeriod === "Week") {
        return moment(bucket.startingTime).format("ddd, MMM D");
      }
      return moment(bucket.startingTime).format("D");
    },
    async getClonedPartsChart() {
      this.chart.loading = true;
      try {
        const parsedTime = moment(this.chart.time);
        const normalizedTime = parsedTime.isValid()
          ? parsedTime.startOf(
              this.chart.timePeriod === "Month" ? "month" : "day",
            ).toISOString()
          : new Date().toISOString();
        const params = new URLSearchParams({
          period: this.chart.timePeriod,
          time: normalizedTime,
        });
        const institutionId = this.selectedInstitutionId;
        if (institutionId) {
          params.append("institution_id", institutionId);
        }

        const response = await getRequest("/part-clone/chart", params.toString());
        const buckets = Array.isArray(response) ? response : [];
        const labels = buckets.map((bucket) => this.getChartLabel(bucket));

        const clonedData = buckets.map((bucket) => ({
          x: bucket.startingTime,
          y: bucket.clonedParts || 0,
        }));
        const approvedData = buckets.map((bucket) => ({
          x: bucket.startingTime,
          y: bucket.approvedParts || 0,
        }));
        const approvedWithExtractedAiCodeData = buckets.map((bucket) => ({
          x: bucket.startingTime,
          y: bucket.approvedPartsWithExtractedLabelOemCodeAI || 0,
        }));

        this.chart.data = {
          labels,
          datasets: [
            {
              label: "Cloned Parts",
              data: clonedData,
              backgroundColor:
                this.chart.type === "line"
                  ? "rgba(251,140,0,0.1)"
                  : "rgba(251,140,0,0.5)",
              borderColor: "rgba(251,140,0,1)",
            },
            {
              label: "Approved Parts",
              data: approvedData,
              backgroundColor:
                this.chart.type === "line"
                  ? "rgba(67,160,71,0.1)"
                  : "rgba(67,160,71,0.5)",
              borderColor: "rgba(67,160,71,1)",
            },
            {
              label: "Approved Parts (Extracted Label OEM Code AI)",
              data: approvedWithExtractedAiCodeData,
              backgroundColor:
                this.chart.type === "line"
                  ? "rgba(30,136,229,0.1)"
                  : "rgba(30,136,229,0.5)",
              borderColor: "rgba(30,136,229,1)",
            },
          ],
        };
      } catch {
        this.chart.data = { labels: [], datasets: [] };
      } finally {
        this.chart.loading = false;
      }
    },
    selectChartType(type) {
      this.chart.type = type;
      this.getClonedPartsChart();
    },
    async getParts() {
      const requestId = ++lastRequestId;
      this.loading = true;

      const sort = this.pagination.sortBy?.[0] || {
        key: "date_created",
        order: "desc",
      };
      try {
        const response = await getRequest(
          "/part-clone/datatable/",
          `page=${this.pagination.page}&limit=${this.pagination.itemsPerPage}`,
        );
        if (requestId !== lastRequestId) return;
        // this.$scrollToTop();
        this.totalItems = response.count;
        this.parts = response.parts || [];
        this.loading = false;
      } catch {
        this.loading = false;
      } finally {
        // this.loading = false;
      }
    },
    regularSearch(data) {
      const requestId = ++lastRequestId;
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "date_created",
        order: "desc",
      };
      getRequest(
        "/part-clone/search/",
        `search_field=${data.searchField}&page=${this.pagination.page}&limit=${this.pagination.itemsPerPage}`,
      )
        .then((response) => {
          // this.$scrollToTop();
          if (requestId !== lastRequestId) return;
          this.totalItems = response.count;
          this.parts = response.parts;
          if (response.count === 0) {
            this.checkVehiclesNew(null, null, response.rr || null);
          }
          this.loading = false;
        })

        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          // this.loading = false;
        });
    },
    advancedSearch(data) {
      const requestId = ++lastRequestId;
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "date_created",
        order: "desc",
      };
      getRequest(
        "/part/inventory/search/advanced",
        `institution_id=${this.$store.getters.institutionId}&role=${
          this.$store.getters.role
        }&limit=${this.pagination.itemsPerPage}&page=${
          this.pagination.page
        }&sort_by=${sort.key}&descending=${
          sort.order === "desc"
        }&search_field=${data.searchField}&language=${
          this.$store.getters.language
        }&title_code=${data.titleCode}&title_codes=${data.titleCodes}&type=${
          data.type
        }&brand=${data.advancedSearchFields.brand}&positionCode=${
          data.advancedSearchFields.positionCode
        }&position=${data.advancedSearchFields.position}&eBayStatus=${
          data.advancedSearchFields.eBayStatus
        }&isNewPart=${data.advancedSearchFields.isNewPart}&no_shipping_cost=${
          data.advancedSearchFields.no_shipping_cost
        }&invalid_category=${
          data.advancedSearchFields.invalid_category
        }&model=${data.advancedSearchFields.model}&version=${
          data.advancedSearchFields.version
        }&institution=${data.advancedSearchFields.institution}&shipment=${
          data.advancedSearchFields.shipment
        }&status=${data.advancedSearchFields.status}&quality=${
          data.advancedSearchFields.quality
        }&price=${data.advancedSearchFields.price}&start_date=${
          data.advancedSearchFields.startDate
        }&end_date=${data.advancedSearchFields.endDate}&no_applicability=${
          data.advancedSearchFields.noApplicability
        }&no_notes=${data.advancedSearchFields.noNotes}&note=${
          data.note
        }&code=${data.code}&repository=${data.advancedSearchFields.repository}`,
      )
        .then((response) => {
          // this.$scrollToTop();
          if (requestId !== lastRequestId) return;
          this.totalItems = response.count;
          this.parts = response.parts;
          // if the brand and model are specified but there are no results, check if there are any
          // inserted vehicles with the specified details.
          if (response.count === 0) {
            this.checkVehiclesNew(
              data.advancedSearchFields.brand,
              data.advancedSearchFields.model,
              response.rr || null,
            );
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          // this.loading = false;
        });
    },
    deletePart(id, kromeda) {
      this.idToDelete = id;
      this.kromedaToDelete = kromeda;
      this.dialogDelete = true;
    },
    confirmDelete() {
      this.loading = true;
      deleteRequest(
        `/part/inventory/${this.idToDelete}`,
        this.kromedaToDelete
          ? `kromeda_id=${this.kromedaToDelete._id}
            &user_id=${
              this.$store.getters.userId
            }&institution_id=${this.$store.getters.institutionId}`
          : `user_id=${
              this.$store.getters.userId
            }&institution_id=${this.$store.getters.institutionId}`,
      )
        .then((response) => {
          if (response) {
            this.idToDelete = null;
            this.kromedaToDelete = null;
            this.dialogDelete = false;
            this.$emit("delete");
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    checkVehicles(brand, model, rr) {
      if (brand && model) {
        getRequest(
          "/car/count",
          `brand=${brand}&model=${model}&institution_id=${this.$store.getters.institutionId}`,
        )
          .then((response) => {
            if (response.count > 0) this.$emit("show-cars", { brand, model });
          })
          .catch(() => {})
          .finally(() => {});
      }
    },

    checkVehiclesNew(brand, model, rr = null) {
      // ✅ Case 1: No brand/model, but rr is true → directly open modal with rr flag
      if ((!brand || !model) && rr) {
        this.$emit("show-cars", { rr });
        return;
      }
      // ✅ Case 2: Brand and model exist → call API
      if (brand && model) {
        getRequest(
          "/car/count",
          `brand=${brand}&model=${model}&institution_id=${this.$store.getters.institutionId}`,
        )
          .then((response) => {
            if (response.count > 0) {
              // Emit show-cars and pass rr flag if applicable
              this.$emit("show-cars", { brand, model, rr });
            } else if (rr) {
              this.$emit("show-cars", { rr });
            }
          })
          .catch(() => {});
      }
    },
    edit(data) {
      this.$refs.viewDialog.open(data);
    },
    share(data) {
      this.$emit("share", data);
    },
    actions(data) {
      this.$emit("actions", { part: data });
    },
    details(data) {
      this.$refs.detailsDialog.open(data);
    },
    movement(data) {
      this.$refs.movementDialog.open(data);
    },
    openQrDialog(data) {
      this.$refs.qrDialog.open(data);
    },
    showImages(images) {
      this.$refs.imgCarousel.open({ type: "string", images });
    },
    viewCar(carId) {
      this.$refs.carDialog.open({ carId });
    },
    // updatePagination() {
    //   this.activeRow = null;
    // },
    updatePagination(options) {
      this.pagination = {
        ...options,
        itemsPerPage: options.itemsPerPage ? options.itemsPerPage : 5,
        groupBy:
          options.groupBy && options.groupBy.length
            ? options.groupBy
            : ["date_created"],
        sortBy:
          options.sortBy && options.sortBy.length
            ? options.sortBy
            : { key: "date_created", order: "desc" },
        sortDesc:
          options.sortDesc && options.sortDesc.length
            ? options.sortDesc
            : [true],
      };
      this.activeRow = null;
    },
    getPosition(code) {
      switch (code) {
        case "S001":
          return this.$t("left");
        case "S002":
          return this.$t("right");
        default:
          return "";
      }
    },
    openEditDialog(item) {
      this.currentItem = item;
      this.editedPrice = item.price;
      this.editDialog = true;
    },
    toggleMenu(item) {
      // if same item clicked again, close it
      if (this.activeEditId === item._id) {
        this.activeEditId = null;
        return;
      }
      // open menu for this item
      this.activeEditId = item._id;
      this.editedPrice = item.price;
      this.currentItem = item;
    },
    savePriceDialog() {
      if (this.currentItem) {
        this.currentItem.price = this.editedPrice;
        this.savePrice(this.currentItem, this.editedPrice);
      }
      this.editDialog = false;
    },

    savePrice(item, price) {
      this.loadingPage = true;
      putRequest("/part/price", `id=${item._id}`, { price })
        .then((response) => {
          if (
            this.$store.getters.institutionExportEbayLeko &&
            item.eBayStatus
          ) {
            if (
              response.data &&
              response.data.ebayError &&
              response.data.ebayError != null
            ) {
              this.$emit("show-error-modal", response.data.ebayError);
            }
          }
          this.refreshParts();
        })
        .catch(() => {})
        .finally(() => {
          this.loadingPage = false;
          this.editDialog = false;
          this.activeEditId = null;
        });
    },
    cancelPrice() {
      this.editDialog = false;
      this.activeEditId = null;
      this.editedPrice = null;
      this.refreshParts();
    },

    refreshParts() {
      if (this.searchObject.type === null) {
        this.getParts();
      } else if (this.searchObject.type === "regularSearch") {
        this.regularSearch(this.searchObject.data);
      } else if (this.searchObject.type === "advancedSearch") {
        this.advancedSearch(this.searchObject.data);
      } else {
        //
      }
    },
    showNotes(notes) {
      this.$emit("show-notes", notes);
    },
    showRefusalReason(reason) {
      this.$emit("show-refusal-reason", reason);
    },
    clearSelected() {
      // invoked from the 'Inventory' view
      this.selected = [];
    },
    openEbayLink(item) {
      this.$emit("see-ebay-items", item);
    },
    openGoogleLink(item) {
      //TBD
      // let url = ``
      // window.open(url,'_blank');
    },
    generateTitle(item) {
      if (!item) return "";
      if (item.eBayTitle) return item.eBayTitle;

      const language = this.$store.getters.language;
      const manufacturerCode =
        item.infoCar && item.infoCar.oemCode ? item.infoCar.oemCode : "";
      const descriptionTitle =
        item.infoCar &&
        item.infoCar.description &&
        item.infoCar.description.descriptionId &&
        item.infoCar.description.descriptionId.title
          ? item.infoCar.description.descriptionId.title[language]
          : "";
      const position =
        item.infoCar &&
        item.infoCar.description &&
        item.infoCar.description.positionCode
          ? this.getPosition(item.infoCar.description.positionCode)
          : "";
      const qr = item.old_id.slice(-6);
      return `${manufacturerCode} ${descriptionTitle} ${position} ${qr}`.trim();
    },
    checkMovement(item) {
  return item.movement_history?.some(
    (movement) =>
      movement.movement_data &&
      movement.movement_data.source === "Insert Parts" &&
      movement.movement_data.destination === "Sales"
  );
},
    toggleSelection(item) {
      const index = this.selected.findIndex((s) => s._id === item._id);
      if (index === -1) {
        this.selected.push(item);
      } else {
        this.selected.splice(index, 1);
      }
    },
    handleScroll() {
      this.showScrollTop = window.scrollY > 300; // show button after scrolling down 300px
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    positionAlertItems(item) {
      const mismatches = item?.alerts?.mismatches;
      if (!Array.isArray(mismatches)) return [];
      return mismatches.filter((a) => a && a.field === "position");
    },
    getAlertIcon(type) {
      switch (type) {
        case "info":
          return "mdi-information";
        case "warning":
          return "mdi-alert-circle";
        case "error":
          return "mdi-close-octagon";
        default:
          return "";
      }
    },
    getAlertColor(type) {
      switch (type) {
        case "info":
          return "blue";
        case "warning":
          return "orange";
        case "error":
          return "red";
        default:
          return "";
      }
    },
    digitalizationAccuracyIcon(value) {
      switch (value) {
        case "full_match":
          return "mdi-check-circle";
        case "partial_match":
          return "mdi-circle-half-full";
        case "no_match":
          return "mdi-close-circle";
        default:
          return "mdi-help-circle-outline";
      }
    },
    digitalizationAccuracyColor(value) {
      switch (value) {
        case "full_match":
          return "green";
        case "partial_match":
          return "orange";
        case "no_match":
          return "red";
        default:
          return "grey";
      }
    },
    digitalizationAccuracyLabel(value) {
      switch (value) {
        case "full_match":
          return "Full Match";
        case "partial_match":
          return "Partial Match";
        case "no_match":
          return "No Match";
        default:
          return "Not Digitalized";
      }
    },
  },
};
</script>
<style scoped>
.wrap {
  white-space: pre-line !important;
  text-align: center;
  height: 42px;
}
.v-data-table-header th {
  white-space: nowrap !important;
}
.scroll-top-btn {
  position: fixed;
  bottom: 45px;
  right: 15px;
  z-index: 9999;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}
</style>
